'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('richemont/experience/components/mainHeader'));
    const $desktopSearchContainer = $('.search-desktop');
    const $desktopSearchIcon = $desktopSearchContainer.find('.search-icon');
    const $logoImage = $('.navbar-header .brand');

    $desktopSearchIcon.on('click', function (e) {
        e.preventDefault();
        $logoImage.addClass('expand-input-field');
        $('nav').addClass('expand-input-field');
        $('.search-mobile').removeClass('d-lg-none');
        $('.search-field:visible').first().focus();
    });
});
